import angular from "angular";

angular
    .module('app')
    .component('userCourseControl', {
        template: require('./user-course-control.html'),
        controller: ['$http', 'Notifier', 'ErrorResponseParser', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, Notifier, ErrorResponseParser) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.user = $ctrl.resolve.user;
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.group = $ctrl.resolve.group;

        setStatus();
    };

    function setStatus() {
        $ctrl.course.chapters.forEach(function (chapter) {
            chapter.lessons.forEach(function (lesson) {
                lesson.can_open = getLessonCanOpen(lesson);
                lesson.status = getLessonStatus(lesson);
            });
        });
    }

    function getLessonCanOpen(lesson) {
        let userLessonStatus = $ctrl.user.lesson_statuses.find(v => v.lesson_id == lesson.id);
        if (userLessonStatus) {
            return userLessonStatus.can_open;
        }
    }

    function getLessonStatus(lesson) {
        let userLessonStatus = $ctrl.user.lesson_statuses.find(v => v.lesson_id == lesson.id);
        if (userLessonStatus) {
            return userLessonStatus.status;
        }
    }

    $ctrl.openAllLessons = function () {
        let url = '/admin/users/' + $ctrl.user.id + '/open-all-lessons';
        let data = {
            courseId: $ctrl.course.id,
        }
        $http.post(url, data).then(
            function () {
                $ctrl.user.lesson_statuses.forEach(function (lessonStatus) {
                    lessonStatus.can_open = true;
                });
                setStatus();
            }
        );
    }

    $ctrl.updateLessonAccess = function (lesson) {

        if ($ctrl.updateLoading) {
            alert('Идет обновление. Повторите чуть позже');
            return;
        }

        $ctrl.updateLoading = true;

        $http
            .post(`/admin/users/${$ctrl.user.id}/update-lesson-access`, {
                lesson_id: lesson.id,
                can_open: lesson.can_open
            })
            .then(
                function () {
                    $ctrl.updateLoading = false;

                    let userLessonStatus = $ctrl.user.lesson_statuses.find(v => v.lesson_id == lesson.id);
                    userLessonStatus.can_open = lesson.can_open;

                    Notifier.success('Успешно обновлен', 1);
                },
                function (error) {
                    $ctrl.updateLoading = false;
                    lesson.can_open = !lesson.can_open;
                    ErrorResponseParser.parse(error);
                    Notifier.error('Произошла ошибка с текстом:' + error.data.message, 2);
                }
            );
    };

    $ctrl.changeCourseStatus = function(status){

        $ctrl.loading = true;

        if (!confirm('Вы действительно хотите изменить статус курса?')) {
            return;
        }

        $http
            .post(`/admin/users/${$ctrl.user.id}/update-course-status`, {
                course_id: $ctrl.course.id,
                status: status,
            })
            .then(
                function (response) {
                    Notifier.success('Статус успешно обновлен', 3);
                    $ctrl.close({$value:{status: response.data.status}});
                    $ctrl.loading = false;
                },
                function (error) {
                    $ctrl.loading = false;
                    ErrorResponseParser.parse(error);
                }
            )
    }

    $ctrl.closeCourse = function(){
        if (!confirm('Вы действительно хотите закрыть курс для студента?')) {
            return;
        }

        $ctrl.closeLoading = true;

        $http
            .post(`/admin/courses/${$ctrl.course.id}/individual-training/closed-course`, {
                user_id: $ctrl.user.id
            })
            .then(
                function () {
                    Notifier.success('Курс успешно закрыт для студента', 3);
                    $ctrl.close();
                    $ctrl.user.pivot.status = 'closed';
                    $ctrl.closeLoading = false;
                },
                function (error) {
                    $ctrl.closeLoading = false;
                    ErrorResponseParser.parse(error);
                }
            )

    };

    $ctrl.detach = function () {

        if (!confirm('Вы действительно хотите удалить студента с курса?')) {
            return;
        }

        $ctrl.detachLoading = true;

        if ($ctrl.group) {
            $http
                .post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/detach-student`, {
                    user_id: $ctrl.user.id
                })
                .then(
                    function () {
                        Notifier.success('Студент успешно удален с курса', 3);
                        $ctrl.close({$value: {action: 'detach'}});
                        $ctrl.detachLoading = false;
                    },
                    function (error) {
                        $ctrl.detachLoading = false;
                        ErrorResponseParser.parse(error);
                    }
                )
        } else {
            $http
                .post(`/admin/courses/${$ctrl.course.id}/individual-training/detach-student`, {
                    user_id: $ctrl.user.id
                })
                .then(
                    function () {
                        Notifier.success('Студент успешно удален с курса', 3);
                        $ctrl.close({$value: {action: 'detach'}});
                        $ctrl.detachLoading = false;
                    },
                    function (error) {
                        $ctrl.detachLoading = false;
                        ErrorResponseParser.parse(error);
                    }
                )
        }
    };

}
